import { storeEvents as financeEvents } from './finance'

export const storeEvents: Record<string, any> = {
  ...financeEvents,
}
